if (!customElements.get('feature-filter-slider')) {
  customElements.define(
    'feature-filter-slider',
    class FinishFilterSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          wrapper: '.pdi-featured-filter-items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination'
        };

        this.classes = {
          swiper: 'swiper',
          wrapper: 'swiper-wrapper'
        };

        // each block has its own instance
        this.enableSlider = this.dataset.enableSlider !== 'false';

        if (!this.enableSlider) return;

        this.wrapper = this.querySelector(this.selectors.wrapper);

        this.init();
        window.addEventListener('resize', () => this.init());
      }

      init() {
        this.initSlider();
      }

      initSlider() {
        // ensure wrapper exists
        if (!this.wrapper) return;

        this.sliderOptions = {
          slidesPerView: 'auto',
          spaceBetween: 24,
          mousewheel: { enabled: true, forceToAxis: true },
          pagination: {
            el: this.querySelector(this.selectors.pagination),
            type: 'progressbar'
          }
        };

        if (!this.sliderInstance) {
          this.classList.add(this.classes.swiper);
          this.wrapper.classList.add(this.classes.wrapper);

          this.sliderInstance = new window.FoxTheme.Carousel(
            this,
            this.sliderOptions,
            [FoxTheme.Swiper.Mousewheel]
          );

          this.sliderInstance.init();
        }
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", () => {
  const productGridSection = document.querySelector(
    ".collection-section[id^='shopify-section-']"
  );

  if (productGridSection) {
    const realSectionId = productGridSection.id.replace("shopify-section-", "");

    // IMPORTANT: update ALL filter forms so all blocks work
    document.querySelectorAll("form.finish-filter-pdi[is='facet-form']")
      .forEach((form) => {
        form.dataset.sectionId = realSectionId;
      });
  }

  // Handle swatch item click (checkbox toggle)
  document.querySelectorAll(".pdi-featured-filter-item").forEach((item) => {
    item.addEventListener("click", (e) => {
      if (e.target.tagName === "INPUT") return;

      e.preventDefault();

      const checkbox = item.querySelector("input[type='checkbox']");
      checkbox.checked = !checkbox.checked;

      checkbox.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });
});
